export const features: Record<string, string[]> = {
  local: ['allLocalAvailable', 'catalogue', 'settings'],
  dev: ['allLocalAvailable', 'catalogue', 'settings'],
  uat: ['allLocalAvailable', 'catalogue', 'settings'],
  uat_in: ['EN'],
  prod: [],
};
